import { render, staticRenderFns } from "./pogs-list--cases.vue?vue&type=template&id=71573e8a&"
import script from "./pogs-list--cases.vue?vue&type=script&lang=js&"
export * from "./pogs-list--cases.vue?vue&type=script&lang=js&"
import style0 from "./pogs-list--cases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports